import script from "./BootstrapMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BootstrapMenu.vue?vue&type=script&setup=true&lang=js"

import "./BootstrapMenu.vue?vue&type=style&index=0&id=30cf7f68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cf7f68"]])

export default __exports__